import React, {forwardRef} from 'react';
import './WhiteButton.css';

const WhiteButton = ({id, name, disable, selected, onClick, onMouseDown, onMouseUp, width, style, authority = true, tooltip = false}, ref) => {
    const buttonStyle  = {...style};
    if (width != undefined) {
        buttonStyle.width = width;
    }
    if (!authority) {
        return;
    }

    return (
        <button 
            id={id} 
            className={"whiteButton "+ (disable ? 'disabled' : selected ? 'selected' : '')} 
            disabled={disable} 
            onClick={onClick} 
            onMouseDown={onMouseDown} 
            onMouseUp={onMouseUp} 
            ref={ref} 
            style={buttonStyle}
            title={tooltip ? name : ''}>
            {name}
        </button>
    )
};
export default forwardRef(WhiteButton);